import { createAsyncThunk } from "@reduxjs/toolkit"

import { API } from "redux/api"

export const fetchPlans = createAsyncThunk("plans/fetch", async () => {
  const response = await API.get("/plan_groups")
  return response.data.plans
})
